module.exports = __webpack_public_path__ + "images/pages/for_business/pc/btn_3_85dc6ffe03771884563ee2ab00bdfe2c.png";